module.exports = __webpack_public_path__ + "media/1alB-t-tap.d332d0e4.mp3";